import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      {/* Left: nav links */}
      <nav className="footer-nav" aria-label="Footer navigation">
        {/*<Link to="/careers">Careers</Link>
        <span className="footer-sep" aria-hidden="true">|</span>
        <Link to="/blogs">Blogs</Link>*/}
        <span className="footer-sep" aria-hidden="true">|</span>
        <Link to="/sitemap">Sitemap</Link>
        <span className="footer-sep" aria-hidden="true">|</span>
        <Link to="/privacy-policy">Privacy Policy</Link>
      </nav>

      {/* Center: copyright */}
      <span className="footer-copy">
        &copy; {new Date().getFullYear()} Morphis. All rights reserved.
      </span>

      {/* Right: social + CTA */}
      <div className="footer-right">
        <a
          href="https://www.linkedin.com/company/morphis-capital-management/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social"
          aria-label="Morphis on LinkedIn"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </a>
        <span className="footer-sep" aria-hidden="true">|</span>
        <Link to="/contact" className="footer-newsletter-link">Get in Touch</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
